import { createFileRoute } from "@tanstack/react-router";
import { SharedPage } from "../screens/sharing/index.ts";

/** `/shared#<token>`: the page behind a public link. */
export const Route = createFileRoute("/shared")({
  component: SharedPage,
});
